import { inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResolveFn } from '@angular/router';

export function setTitle(titleName: string): ResolveFn<string> {
    return () => inject(TranslateService).get(titleName);
}
